let Lang = {
    en : {
        empty_field : 'The field is not filled',
        invalid_email_field: 'Invalid e-mail',
        file_max_size_field: 'The file exceeds the maximum size ',
        incorrect_file_field: 'Incorrect file',
        incorrect_format_file_field: 'Incorrect file format',
        agree_agreement_field: 'You must agree to the user agreement'
    },
    ru : {
        empty_field: 'Поле не заполнено',
        invalid_email_field: 'Некорректный e-mail',
        file_max_size_field: 'Размер файла превышает максимальный ',
        incorrect_file_field: 'Некорректный файл',
        incorrect_format_file_field: 'Некорректный формат файла',
        agree_agreement_field: 'Необходимо ваше согласие с пользовательским соглашением'
    },
    getLangMessage: function(){
        if($('body').hasClass('en')){
            return Lang.en;
        }else{
            return Lang.ru;
        }
    }
}

export default {
  message: Lang.getLangMessage()
};


// WEBPACK FOOTER //
// ./components/lang-message.js